import { render } from "./SubgrupoList.vue?vue&type=template&id=a2508fd2&scoped=true"
import script from "./SubgrupoList.vue?vue&type=script&lang=js"
export * from "./SubgrupoList.vue?vue&type=script&lang=js"

import "./SubgrupoList.vue?vue&type=style&index=0&id=a2508fd2&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2508fd2"]])

export default __exports__